module.exports = __webpack_public_path__ + "img/phone_dark.c3ae7e58.svg";